export const PXVideos = (function() {
	'use strict';

	let $videoTrigger = $('.pxblock--videos .video-trigger');

	function init() {
		events();
	}

	function events() {
		$videoTrigger.on('click', function(e) {
			$(this).addClass('active').siblings().removeClass('active');
			let iframeUrl = $(this).data('iframe-url');
			let $iframe = $(this).closest('.videos-condensed').find('iframe');	
			$iframe.attr('src', iframeUrl);
		});
	}
	
	return {
		init: init
	};
})();
